import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ClientModelInput } from "../types";

export const useClientModelInputs = (
  model_id: string,
  input_names: string[],
  time_periods: string[]
) => {
  const inputs_query = input_names.length
    ? `?${input_names.map((v) => `name=${v}`).join("&")}`
    : "";
  const periods_query = time_periods.length
    ? `${inputs_query.length > 0 ? "&" : "?"}${time_periods.map((v) => `period=${v}`).join("&")}`
    : "";

  return useQuery({
    queryKey: ["client", "inputs", model_id, inputs_query, periods_query],
    enabled:
      model_id.length > 0 && input_names.length > 0 && time_periods.length > 0,
    staleTime: Infinity, // Data never becomes stale unless explicitly invalidated
    refetchOnMount: true, // Will only refetch if manually invalidated
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/inputs${inputs_query}${periods_query}`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ClientModelInput[];
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
